// extracted by mini-css-extract-plugin
export default {"plantsSection":"Plants_plantsSection__z3Aeu","plantsGrid":"Plants_plantsGrid__S3dB+","plantCard":"Plants_plantCard__bGqAu"};